import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import {
  demoSystemModules,
  demoRoles,
  demoPanels,
  twinFlow,
  twinStats,
} from '@/mocks/demo';

export default function TwinConsole() {
  const [active, setActive] = useState('消费者');
  const panel = demoPanels[active];

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="数字孪生演示"
            title="九畴云市 · 数字经济操作系统"
            subtitle="切换角色视角，直观理解九畴云市如何把「人、货、店、场、数据、消费」连接起来。"
          />
        </Reveal>

        {/* 系统模块栏 */}
        <Reveal delay={80}>
          <div className="mt-10 grid grid-cols-3 sm:grid-cols-6 gap-3">
            {demoSystemModules.map((m) => (
              <div
                key={m.key}
                className="p-3 rounded-lg bg-primary-500 text-background-50 text-center"
              >
                <div className="w-8 h-8 mx-auto flex items-center justify-center">
                  <i className={`${m.icon} text-xl`}></i>
                </div>
                <div className="mt-1 text-xs font-medium whitespace-nowrap">{m.key}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* 左侧：数字孪生主面板 */}
          <Reveal delay={120}>
            <div className="lg:col-span-2 space-y-4">
              {/* 0# 帝星实时面板 */}
              <div className="p-6 rounded-lg bg-foreground-950 border border-foreground-800">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                    <span className="text-background-50 font-medium">0# 帝星咖啡</span>
                  </div>
                  <span className="px-2 py-0.5 text-[10px] rounded-full bg-accent-500/20 text-accent-300 border border-accent-500/30 whitespace-nowrap">
                    运行中
                  </span>
                </div>
                <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {twinStats.map((s) => (
                    <div key={s.k} className="p-3 rounded-md bg-foreground-900">
                      <div className="text-xs text-foreground-400">{s.k}</div>
                      <div className="mt-1 font-heading font-bold text-lg text-accent-400">
                        {s.v}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* 复制链路 */}
              <div className="p-6 rounded-lg bg-background-100 border border-background-200">
                <div className="text-sm font-medium text-foreground-900 mb-4">复制链路</div>
                <div className="space-y-3">
                  {twinFlow.map((step, i) => (
                    <div key={step.label}>
                      <div className="flex items-center gap-3">
                        <div
                          className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${
                            step.active
                              ? 'bg-accent-500 text-background-50'
                              : 'bg-background-200 text-foreground-500'
                          }`}
                        >
                          {i === 0 ? '0#' : i === 1 ? '1#' : i + 1}
                        </div>
                        <div className="flex-1">
                          <div className="text-sm font-medium text-foreground-900">
                            {step.label}
                          </div>
                          <div className="text-xs text-foreground-500">{step.sub}</div>
                        </div>
                      </div>
                      {i < twinFlow.length - 1 && (
                        <div className="ml-4 mt-2 h-6 w-px bg-background-300"></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          {/* 右侧：角色交互 */}
          <Reveal delay={160}>
            <div className="p-6 rounded-lg bg-background-100 border border-background-200">
              <div className="text-sm font-medium text-foreground-900 mb-4">选择角色体验</div>
              <div className="flex flex-wrap gap-2">
                {demoRoles.map((r) => (
                  <button
                    key={r.key}
                    onClick={() => setActive(r.key)}
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-full cursor-pointer whitespace-nowrap transition-colors ${
                      active === r.key
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-50 text-foreground-600 border border-background-200 hover:border-primary-300'
                    }`}
                  >
                    <i className={`${r.icon} text-sm`}></i>
                    {r.key}
                  </button>
                ))}
              </div>

              <div className="mt-6 p-5 rounded-lg bg-background-50 border border-background-200">
                <div className="font-heading font-bold text-foreground-950">{panel.title}</div>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{panel.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {panel.stats.map((s) => (
                    <span
                      key={s}
                      className="px-2.5 py-1 text-[11px] rounded-full bg-accent-100 text-accent-900 whitespace-nowrap"
                    >
                      {s}
                    </span>
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t border-background-200">
                  <div className="text-xs text-foreground-500 leading-relaxed">{panel.detail}</div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}